<div class="padding flex column fix-width">
	<b class="margin-bottom-small">Total cost</b>

	<div class="flex column">
		<div class="flex">
			<input matInput type="number" min="0" class="full-width" [(ngModel)]="finalCost" />
			<div class="flex center bg-light-grey padding-right padding-left nowrap">€ Euro</div>
		</div>
	</div>

	<div class="bg-light-grey padding-small margin-top-small">
		<div class="border radius padding-small margin-top-smallest bg-white">
			<div>
				<b>Total SKU:</b>
				{{ totalSku || '-' }}
			</div>
			<div>
				<b>Cost per SKU:</b>
				{{ singleSkuCost !== null ? (singleSkuCost | currency: 'EUR' : 'symbol' : '1.2-2') : '-' }}
			</div>
		</div>
	</div>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			<button (click)="save()" [disabled]="loading">
				<i class="fa-solid fa-check"></i>
				Save
			</button>
		</div>
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
